export const ERROR_500 = 'サーバーでエラーが発生しました。管理者に問い合わせてください'
export const ERROR_404 = 'データが見つかりませんでした。入力に問題ないか確認してください'